import {Pipe, PipeTransform} from "@angular/core";
import {SimScenarioService} from "@services";
import {Scenario} from "@models";
import {from, Observable} from "rxjs";

@Pipe({
	name: "getScenarioById",
	standalone: true,
})
export class GetScenarioByIdPipe implements PipeTransform {
	constructor(private _simScenarioService: SimScenarioService) {}

	transform(value: string, ...args: unknown[]): Observable<Scenario> {
		return from(this._simScenarioService.getScenarioById(value));
	}
}
